var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.387 9.254a4.095 4.095 0 0 1-2.481.835 4.136 4.136 0 0 1-4.129-4.13 4.14 4.14 0 0 1 4.129-4.128 4.14 4.14 0 0 1 4.128 4.129c0 .976-.338 1.87-.91 2.58l2.764 2.765c.099.098.142.23.142.36a.499.499 0 0 1-.507.518.512.512 0 0 1-.36-.147L8.387 9.254zM2.47 5.96a3.45 3.45 0 0 0 3.436 3.436A3.45 3.45 0 0 0 9.342 5.96a3.453 3.453 0 0 0-3.436-3.437A3.453 3.453 0 0 0 2.47 5.96z",
    fill: "gray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcSearch);
export default __webpack_public_path__ + "static/media/icon-ic-search.cec0b026487c5739f2cc17ec97c06d84.svg";
export { ForwardRef as ReactComponent };